<template>
  <div class="wrapper">
    <div class="out-box">
      <ModuleTextHeader :title="title" :describe="describe" :emphasis="emphasis" :dot-color="dotColor" :style-type="componentType" />
      <div class="content">
        <!-- 头像轮播区域 -->
        <div class="avatar-carousel">
          <div ref="carouselContainer" class="carousel-container">
            <div
              ref="carouselTrack"
              class="carousel-track"
              :style="{ transform: `translateX(${translateX}px)` }"
            >
              <div
                v-for="(item, index) in displayList"
                :key="`${item.id || index}-${index}`"
                ref="carouselItem"
                class="carousel-item"
                @click="handleAvatarClick(index)"
              >
                <div
                  class="avatar-item"
                  :class="{ 'active': currentIndex === (index % dataList.length) }"
                >
                  <img
                    v-lazy-load :data-src="item.imageUrl"
                    :alt="item.webAltInfo"
                    class="avatar-image"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 用户信息展示区域 -->
        <div v-if="currentUser" class="user-info">
          <div class="user-name">
            {{ currentUser.name }}
          </div>
          <div class="user-describe">
            {{ currentUser.describe }}
          </div>
          <div class="user-score">
            <CommentsRate :rate-level="Number(currentUser.score)" />
          </div>
          <div class="user-evaluate">
            <span class="user-evaluate-pc">{{ currentUser.evaluate }}</span>
            <span class="user-evaluate-touch">{{ displayEvaluate }}</span>
            <img class="quota-img left" v-lazy-load data-src="~assets/images/userComments/quota.png">
            <img class="quota-img right" v-lazy-load data-src="~assets/images/userComments/quota.png">
            <img
              v-if="showExpandButton"
              class="arrow-down"
              :class="{ 'expanded': isExpanded }"
              v-lazy-load data-src="~assets/images/userComments/arrow-down.png"
              @click="toggleExpand"
            >
          </div>
        </div>
        <img class="triangle-img" v-lazy-load data-src="~assets/images/userComments/triangle.png">
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 评价组件 - 改进的无缝轮播版本
 */
import mixin from './mixin'
import ModuleTextHeader from '../Common/ModuleTextHeader/web.vue'
import CommentsRate from './CommentsRate/web.vue'

export default {
  name: 'UserCommentsTwo',
  components: { ModuleTextHeader, CommentsRate },
  mixins: [mixin],
  data() {
    return {
      currentIndex: 0,
      translateX: 0,
      itemWidth: 171, // 默认桌面端宽度
      autoplayTimer: null,
      isTransitioning: false,
      realIndex: 0, // 真实索引，用于无缝切换
      containerWidth: 0, // 容器宽度
      isExpanded: false, // 全局展开状态，所有文字共用
    }
  },
  computed: {
    currentUser() {
      return this.dataList[this.currentIndex] || null
    },
    // 创建用于无缝轮播的显示列表
    displayList() {
      // 复制数组实现无缝
      return [...this.dataList, ...this.dataList, ...this.dataList]
    },
    // 处理评价文本的显示
    displayEvaluate() {
      if (!this.currentUser || !this.currentUser.evaluate) return ''

      const text = this.currentUser.evaluate
      if (this.isExpanded || text.length <= 120) {
        return text
      }
      return `${text.substring(0, 120)}...`
    },
    // 是否需要显示展开按钮
    showExpandButton() {
      return this.currentUser && this.currentUser.evaluate && this.currentUser.evaluate.length > 120
    },
  },
  mounted() {
    this.updateItemWidth()
    this.initCarousel()
    this.startAutoplay()
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    this.stopAutoplay()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    updateItemWidth() {
      // 根据窗口宽度动态设置itemWidth
      this.itemWidth = window.innerWidth <= 768 ? 91 : 171
    },

    initCarousel() {
      // 获取容器宽度
      this.$nextTick(() => {
        if (this.$refs.carouselContainer) {
          this.containerWidth = this.$refs.carouselContainer.offsetWidth
        }

        const items = Array.isArray(this.$refs.carouselItem)
          ? this.$refs.carouselItem
          : [this.$refs.carouselItem]

        // 最多取前 5 个元素进行平均
        const sampleItems = items.slice(0, 5)
        if (sampleItems.length > 0) {
          const totalWidth = sampleItems.reduce((sum, el) => sum + el.offsetWidth, 0)
          this.itemWidth = Math.round(totalWidth / sampleItems.length)
        }

        this.currentIndex = 0
        this.realIndex = this.dataList.length
        this.updateTranslateX()
      })
    },

    updateTranslateX(noAnimation = false) {
      const centerOffset = (this.containerWidth - this.itemWidth) / 2;
      const ele = this.$refs.carouselTrack;

      if (noAnimation) {
        ele.style.transition = 'none';
      }

      // 更新绑定值
      this.translateX = -this.realIndex * this.itemWidth + centerOffset;

      if (noAnimation) {
        // 让 DOM 完成绑定更新后再访问 offsetHeight
        this.$nextTick(() => {
          ele.offsetHeight;
          ele.style.transition = 'transform 0.3s ease';
        });
      }
    },

    startAutoplay() {
      if (this.dataList.length <= 1) return

      const delay = parseInt(this.delayTime, 10) * 1000 || 3000
      this.autoplayTimer = setInterval(() => {
        this.nextSlide()
      }, delay)
    },

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer)
        this.autoplayTimer = null
      }
    },

    nextSlide() {
      if (this.isTransitioning) return

      this.isTransitioning = true
      this.realIndex += 1
      this.currentIndex = (this.currentIndex + 1) % this.dataList.length
      this.updateTranslateX()

      // 检查是否需要重置位置
      setTimeout(() => {
        if (this.realIndex >= this.dataList.length * 2) {
          // 重置到中间位置，无动画
          this.realIndex = this.dataList.length
          this.updateTranslateX(true)
        }
        this.isTransitioning = false
      }, 300)
    },

    prevSlide() {
      if (this.isTransitioning) return

      this.isTransitioning = true
      this.realIndex -= 1
      this.currentIndex = this.currentIndex === 0 ? this.dataList.length - 1 : this.currentIndex - 1
      this.updateTranslateX()

      // 检查是否需要重置位置
      setTimeout(() => {
        if (this.realIndex < this.dataList.length) {
          // 重置到中间位置，无动画
          this.realIndex = this.dataList.length * 2 - 1
          this.updateTranslateX()
        }
        this.isTransitioning = false
      }, 300)
    },

    goToSlide(index) {
      if (this.isTransitioning || index === this.currentIndex) return

      this.isTransitioning = true
      const diff = index - this.currentIndex
      this.currentIndex = index
      this.realIndex += diff
      this.updateTranslateX()

      // 检查是否需要重置位置
      setTimeout(() => {
        if (this.realIndex >= this.dataList.length * 2) {
          this.realIndex = this.dataList.length + index
          this.updateTranslateX()
        } else if (this.realIndex < this.dataList.length) {
          this.realIndex = this.dataList.length + index
          this.updateTranslateX()
        }
        this.isTransitioning = false
      }, 300)
    },

    handleAvatarClick(index) {
      // 计算实际的数据索引
      const actualIndex = index % this.dataList.length
      this.goToSlide(actualIndex)
    },

    handleResize() {
      // 窗口大小变化时重新计算容器宽度和位置
      this.$nextTick(() => {
        if (this.$refs.carouselContainer) {
          this.containerWidth = this.$refs.carouselContainer.offsetWidth
        }

        const itemEl = Array.isArray(this.$refs.carouselItem)
          ? this.$refs.carouselItem[0]
          : this.$refs.carouselItem

        if (itemEl) {
          this.itemWidth = itemEl.offsetWidth
        }
        this.updateTranslateX()
      })
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },
  },
}
</script>

<style lang="scss" scoped>
.triangle-img {
  display: block;
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 47px;
  height: 52px;
}

.wrapper {
  position: relative;
  padding-top: 30px;
  height: auto;
  width: 100%;
  background-image:
    url('~assets/images/userComments/hart.png'),       /* 图层2：右上角 hart 图 */
    linear-gradient(180deg, #f8f8f8 0, #f8f8f8 371px, #fff 371px, #fff 100%); /* 图层3：底部渐变 */

  background-repeat: no-repeat, no-repeat;
  background-size:
    371px 340px,          /* hart 图尺寸 */
    100% 100%;            /* 渐变背景填满整个容器 */

  background-position:
    right 31px,            /* 第二张图（hart）右上角 */
    top;                  /* 渐变背景顶对齐 */

  .out-box {
    position: relative;
    width: 1252px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 15px 15px 15px 15px;
    box-shadow: 0 7px 8px 0 #f0f0f0;
    padding-top: 82px;
  }
}

.content {
  padding: 10px 40px 60px;
}

.avatar-carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
}

.carousel-container {
  width: 100%;
  max-width: 814px;
  height: 136px;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
}

.carousel-track {
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;
  height: 100%;
  position: relative;
}

.carousel-item {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 171px; // 固定宽度，包含间距
  cursor: pointer;
  position: relative;
}

.avatar-item {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;

  &.active {
    width: 125px;
    height: 125px;
    box-sizing: border-box;
    border: 5px solid #dcdcdc;
    background-color: #dcdcdc;
    z-index: 10;
    // transform: scale(1.1);
  }

  &:hover {
    transform: scale(1.05);
  }
}

.avatar-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.user-info {
  text-align: center;
  max-width: 708px;
  margin: 0 auto;
}

.user-name {
  font-size: 22px;
  font-family: Roboto-Flex, sans-serif;
  font-weight: 600;
  color: #45454c;
  line-height: 34px;
}

.user-describe {
  font-size: 18px;
  height: 25px;
  color: #999;
  margin-top: 7px;
  margin-bottom: 16px;
}

.user-score {
  margin-bottom: 54px;

  ::v-deep .el-rate {
    .el-rate__icon {
      font-size: 20px;
      margin-right: 4px;
    }
  }
}

.user-evaluate {
  position: relative;
  font-size: 18px;
  font-family: Roboto-Flex, sans-serif;
  font-weight: 500;
  line-height: 32px;
  text-align: left;
  color: var(--txt-color-lv4);

  .user-evaluate-pc {
    display: block;
    height: 160px;
  }

  .user-evaluate-touch {
    display: none;
  }
}

.arrow-down {
  display: none;
}

.quota-img {
  width: 84px;
  height: 84px;
  position: absolute;

  &.left {
    top: -54px;
    left: -135px;
  }

  &.right {
    transform: rotate(180deg);
    top: 35px;
    right: -165px;
  }
}

/* 宽屏桌面（1440px-1919px） */
@media (min-width: 1440px) and (max-width: 1919px) {
  .user-info {
    width: 835px;
  }

  .quota-img {
    width: 60px;
    height: 60px;
  }

  .wrapper {
    background-image: linear-gradient(180deg, #f8f8f8 0, #f8f8f8 369px, #fff 369px, #fff 100%); /* 图层3：底部渐变 */
    background-size: 100% 100%;
    background-position: top;
  }
}

/* 标准桌面（1280px-1439px） */
@media (min-width: 769px) and (max-width: 1439px) {
  .user-info {
    width: 835px;
  }

  .quota-img {
    width: 58px;
    height: 58px;
  }

  .wrapper {
    background-image: linear-gradient(180deg, #f8f8f8 0, #f8f8f8 252px, #fff 252px, #fff 100%); /* 图层3：底部渐变 */
    background-size: 100% 100%;
    background-position: top;

    .out-box {
      width: 1158px;
      padding-top: 73px;
    }
  }
}

/* touch网页样式 */
@media (max-width: 768px) {
  .user-info {
    width: 71.2vw;

    .user-name {
      font-size: 5.333vw;
      line-height: 9.06667vw;
    }

    .user-describe {
      font-size: 4.267vw;
      height: 6.667vw;
      margin-top: 2.4vw;
      margin-bottom: 5.867vw;
    }

    .user-score {
      margin-bottom: 14.4vw;
    }

    .user-evaluate {
      font-size: 4.267vw;

      .user-evaluate-pc {
        display: none;
      }

      .user-evaluate-touch {
        display: block;
        line-height: 8.53333vw;
      }
    }
  }

  .quota-img {
    width: 5.6vw;
    height: 5.6vw;

    &.left {
      top: -7.467vw;
      left: -4.8vw;
    }

    &.right {
      top: auto; // 清除top属性，让bottom生效
      bottom: -6.933vw;
      right: -3.733vw;
    }
  }

  .wrapper {
    width: 100%;
    padding: 0 7.2vw;
    background-color: #f8f8f8;
    height: auto;
    background-image: none;

    .out-box {
      width: auto;
      background: none;
      border-radius: 0;
      box-shadow: none;
      padding-top: 0;
      padding-bottom: 13.067vw;
    }
  }

  .content {
    position: relative;
    width: 86.133vw;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 4vw;
    padding: 0 7.467vw 16vw;

    .avatar-carousel {
      height: 39.2vw;
      justify-content: center;
      margin-bottom: 0;
    }
  }

  .carousel-item {
    width: 24.267vw;
  }

  .avatar-item {
    width: 14.133vw;
    height: 14.133vw;

    &.active {
      width: 21.067vw;
      height: 21.067vw;
      border: 1.333vw solid #dcdcdc;
    }
  }

  .triangle-img {
    display: block;
    position: absolute;
    top: -4.533vw;
    left: 50%;
    transform: translateX(-50%);
    width: 8vw;
    height: 8.8vw;
  }

  .arrow-down {
    display: block;
    position: absolute;
    bottom: 1.867vw;
    right: 0;
    width: 2.933vw;
    height: 1.333vw;
    transition: transform 0.3s ease;
    cursor: pointer;

    &.expanded {
      transform: rotate(180deg);
    }
  }
}
</style>
